var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?[_c('Loading')]:[_c('MySystemBar'),_c('v-app',[(_vm.domaines)?_c('MyMenu',{attrs:{"domaines":_vm.domaines}}):_vm._e(),_c('v-main',[_c('router-view')],1),_c('myFooter')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }